<div class="relative-container">
  <button mat-icon-button (click)="onHistoryClick()" id="history-button"><i class="material-icons">
    history
  </i></button>
</div>
